"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SettingsPageFooter = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _underscore = require("underscore");
var _constants = require("../../../constants");
var _JoinComponent = require("../JoinComponent.styled");
var _propTypes = require("prop-types");
var _constants2 = require("@studio/constants");
var _logger = require("@studio/logger");
var _feature = require("@studio/feature.flags");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var LOG = new _logger.StudioLogger('SettingsPageFooter');

/**
 * SettingsPageFooter component renders the footer for the Settings page with buttons to check system and join meeting.
 * @param {Function} goToPage - Function to navigate to a different page
 * @param {string} checkStatus - Current status of the system check
 * @param {string[]} errors - Array of error messages
 * @param {boolean} hasValidationError - Whether there's a validation error
 * @param {boolean} hasAudioDevice - Whether an audio device is detected
 * @param {boolean} isStandaloneChecker - Whether in standalone checker mode
 * @param {Function} handleJoinMeeting - Function to handle joining the meeting
 * @param {string} sourceLoadStatus - Current status of source loading
 * @param {boolean} isJoinInProgress - Whether the join process is in progress
 * @returns {JSX.Element} The footer component with action buttons
 */
var SettingsPageFooter = exports.SettingsPageFooter = function SettingsPageFooter(_ref) {
  var goToPage = _ref.goToPage,
    checkStatus = _ref.checkStatus,
    errors = _ref.errors,
    hasValidationError = _ref.hasValidationError,
    hasAudioDevice = _ref.hasAudioDevice,
    isStandaloneChecker = _ref.isStandaloneChecker,
    handleJoinMeeting = _ref.handleJoinMeeting,
    sourceLoadStatus = _ref.sourceLoadStatus,
    isJoinInProgress = _ref.isJoinInProgress;
  var checkInProgress = checkStatus === _constants.JOIN_PAGE_STATUS.IN_PROGRESS;
  var hasError = errors.length > 0 && !checkInProgress;
  var browserBlock = checkStatus === _constants.JOIN_PAGE_STATUS.BROWSER_BLOCK;
  var isCheckSystemButtonDisabled = checkInProgress || browserBlock || hasValidationError;
  var isDDSynthetics = window._DATADOG_SYNTHETICS_BROWSER === true;
  var sourcesNotReady = sourceLoadStatus !== _constants2.DONE;
  var shouldRequireAudio = (0, _feature.shouldHaveFeature)('studio.requireAudio');
  var isJoinButtonDisabled = checkInProgress || browserBlock || hasValidationError || hasError || !hasAudioDevice || isStandaloneChecker || isJoinInProgress || sourcesNotReady;
  var goToSystemCheckPage = function goToSystemCheckPage() {
    return goToPage(_constants.JOIN_PAGE.SYSTEM_CHECK);
  };
  var handleJoinClick = (0, _react.useCallback)((0, _underscore.debounce)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return handleJoinMeeting();
        case 3:
          _context.next = 8;
          break;
        case 5:
          _context.prev = 5;
          _context.t0 = _context["catch"](0);
          LOG.error('Join meeting failed', {
            error: _context.t0
          });
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 5]]);
  })), 2000, true), [handleJoinMeeting]);
  if ((!shouldRequireAudio || isDDSynthetics) && !sourcesNotReady) {
    isJoinButtonDisabled = false;
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_JoinComponent.CheckSystemButton, {
    onClick: goToSystemCheckPage,
    color: "outline",
    disabled: isCheckSystemButtonDisabled,
    "data-testid": "check_system_button"
  }, "Check system"), /*#__PURE__*/_react["default"].createElement(_JoinComponent.StyledJoinButton, {
    disabled: isJoinButtonDisabled,
    onClick: handleJoinClick,
    color: "primary",
    "data-testid": "join_button"
  }, "Join"));
};
SettingsPageFooter.propTypes = {
  goToPage: _propTypes.func.isRequired,
  checkStatus: _propTypes.string.isRequired,
  errors: (0, _propTypes.arrayOf)(_propTypes.string).isRequired,
  hasValidationError: _propTypes.bool.isRequired,
  hasAudioDevice: _propTypes.bool.isRequired,
  isStandaloneChecker: _propTypes.bool.isRequired,
  handleJoinMeeting: _propTypes.func.isRequired,
  sourceLoadStatus: _propTypes.string,
  isJoinInProgress: _propTypes.bool
};